var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('image-atom',{staticClass:"vuw-image-cover",attrs:{"url":_vm.asset.url,"description":_vm.asset.description,"fallback":_vm.imageFallback}})}
var staticRenderFns = []

export { render, staticRenderFns }